import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../../../Store';

function PrivacyLink({ label, linkId = 'n/a' }) {
	const state = useContext(AppContext)[0];

	return (
		<a
			href={state.privacyUrl}
			target="_blank"
			rel="noreferrer"
			id={linkId}
		>
			{label}
		</a>
	);
}

export default PrivacyLink;

PrivacyLink.propTypes = {
	label: PropTypes.string.isRequired,
	linkId: PropTypes.string,
};